import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import SEOMeta from "../../components/SEOMeta";
import styles from "../../styles/Button.module.css";
import { useLocation } from "react-router-dom";

// Geo News Hack Incident - March 1, 2026
// Sources: 
// - https://www.24newshd.tv/1-Mar-2026/geo-news-screen-hacked-anti-military-message-aired
// - https://www.dawn.com/news/1977094/geo-news-transmission-hijacked-subversive-message-displayed
// - https://propakistani.pk/2026/03/01/geo-news-satellite-frequency-reportedly-hacked-broadcast-suspended/

const GeoNewsHackIncident: React.FC = () => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const adInitialized = useRef(false); // Add this to prevent double initialization
  const location = useLocation(); // Add this
  
  // Article structured data for SEO
  const articleStructuredData = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: "Geo News Hacked?",
    description:
      "Breaking: Geo News satellite transmission hacked today, March 1, 2026. Unauthorized anti-military messages broadcast before signal disrupted. Latest updates and official response.",
    datePublished: "2026-03-01",
    dateModified: "2026-03-01",
    author: {
      "@type": "Organization",
      name: "CyberAnnals",
    },
    publisher: {
      "@type": "Organization",
      name: "CyberAnnals",
      logo: {
        "@type": "ImageObject",
        url: "https://cyberannals.com/cyberAnnals_logo.png",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://cyberannals.com/blog/geo-news-hack-incident-2026",
    },
  };

  // Timeline data for visual representation
  const timelineEvents = [
    {
      time: "February 28, 2026",
      event: "Initial probing attempts begin",
      description: "Geo News systems face repeated unauthorized access attempts"
    },
    {
      time: "March 1, 2026 - Evening",
      event: "24 hours of persistent attacks",
      description: "Continued attempts to breach security measures"
    },
    {
      time: "March 1, 2026 - Night",
      event: "Satellite feed hijacked",
      description: "Unauthorized content broadcast on Geo News satellite transmission"
    },
    {
      time: "Post-hijack",
      event: "Service disruption",
      description: "Satellite feed goes offline with 'service unavailable' message"
    }
  ];
 // Load Google AdSense ad when component mounts and when event data changes

useEffect(() => { if (adContainerRef.current && typeof window !== 'undefined') { 
  // Clear previous ad content
  adContainerRef.current.innerHTML = ''; 
  // Create ins element for the ad 
  const ins = document.createElement('ins'); 
  ins.className = 'adsbygoogle'; 
  ins.style.display = 'block'; 
  ins.style.textAlign = 'center'; 
  ins.style.minWidth = '300px';
  ins.style.minHeight = '250px';
  ins.setAttribute('data-ad-client', 'ca-pub-9325373695328890'); 
  ins.setAttribute('data-ad-slot', '3721511676'); 
  ins.setAttribute('data-ad-layout', 'in-article') 
    ins.setAttribute('data-ad-format', 'fluid'); 
  // Add the ad element to the container 
  adContainerRef.current.appendChild(ins); 
  // Trigger ad load 
  setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("Adsense error:", e);
      }
    }, 500); // slight delay allows layout to settle
  }
}, [location.pathname]);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 lg:py-12">
      <SEOMeta
        title="Geo News’ transmission hacked; subversive message displayed"
        description="Breaking: Geo News satellite transmission hacked today with anti-military messages. Latest updates on Pakistan's major news channel cyber attack incident."
        keywords="Geo News hacked?, Geo News hack, Geo News hack?, Geo News hacked today, Geo News hacked 2026, Pakistan news channel hacked, Geo News satellite hijack, PEMRA investigation, cyber attack Pakistan media, news channel hack, Geo News latest news, March 1 2026 hack, Pakistani media cyber attack"
        canonical="https://cyberannals.com/blog/geo-news-hack-incident-2026"
        ogType="article"
        structuredData={articleStructuredData}
      />
     <div className="lg:col-span-4 mb-6">
  <div className="text-xs text-slate-400 dark:text-slate-500 mb-8 px-1">Advertisement</div>
  <div className="h-full min-h-[250px] min-w-[250px] w-full bg-white/5 border border-white/10 rounded-2xl relative overflow-hidden"
       id="event-detail-ad"
       ref={adContainerRef}>
  </div>
</div>
      {/* Breaking News Banner */}
      <div className="bg-red-600 dark:bg-red-700 text-white px-4 py-3 rounded-lg mb-6 animate-pulse">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <span className="font-bold text-lg sm:text-xl flex items-center gap-2">
            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            BREAKING: Geo News Hacked -March 1, 2026
          </span>
          <span className="text-sm sm:text-base bg-white text-red-600 px-3 py-1 rounded-full font-semibold">
            Live Update
          </span>
        </div>
      </div>

      <article className="prose prose-sm sm:prose-base lg:prose-lg max-w-none">
        {/* Header Section */}
        <header className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 dark:text-white mb-3 sm:mb-4 leading-tight">
            Geo News’ transmission hacked; subversive message displayed
          </h1>
          <h2>Channel's Transmission Hijacked With Anti-Military Message</h2>
          
          {/* Date and Source Info */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-4 text-sm sm:text-base text-slate-600 dark:text-slate-400 mb-4">
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              March 1, 2026
            </span>
          </div>
        </header>

        {/* Key Alert Cards - Mobile Optimized Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-red-800 dark:text-red-200 text-sm">Attack Type</h3>
                <p className="text-red-600 dark:text-red-300 text-sm font-medium">Satellite Frequency Hijacking</p>
              </div>
            </div>
          </div>

          <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-orange-800 dark:text-orange-200 text-sm">Duration</h3>
                <p className="text-orange-600 dark:text-orange-300 text-sm font-medium">Brief broadcast + Service disruption</p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-yellow-600 dark:text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-yellow-800 dark:text-yellow-200 text-sm">Target</h3>
                <p className="text-yellow-600 dark:text-yellow-300 text-sm font-medium">Satellite Broadcast Feed</p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-blue-800 dark:text-blue-200 text-sm">Digital Platforms</h3>
                <p className="text-blue-600 dark:text-blue-300 text-sm font-medium">Unaffected (Website/App)</p>
              </div>
            </div>
          </div>
        </div>

        {/* YouTube Video Embed - Full responsive with 16:9 aspect ratio */}
<div className="mb-8 sm:mb-10">
  <div className="relative w-full max-w-[560px] mx-auto bg-black rounded-xl overflow-hidden shadow-xl">
    <div className="relative pb-[56.25%]"> {/* 16:9 Aspect Ratio (9/16 = 0.5625) */}
      <iframe 
        className="absolute top-0 left-0 w-full h-full"
        src="https://www.youtube.com/embed/mWsITo90jl8?si=uVTksxo20NbUf9Na" 
        title="Geo News Hack Coverage - March 1, 2026" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerPolicy="strict-origin-when-cross-origin" 
        allowFullScreen
      ></iframe>
    </div>
  </div>
  <p className="text-sm text-slate-600 dark:text-slate-400 mt-2 text-center">
    Video: Geo News satellite transmission hack incident
  </p>
</div>

        {/* Main Content */}
        <div className="space-y-4 sm:space-y-6 text-slate-700 dark:text-slate-300">
          {/* Lead Paragraph */}
          <p className="text-base sm:text-lg font-medium">
            In a significant cybersecurity incident, Pakistan's leading news channel <strong>Geo News experienced a major hack today (March 1, 2026)</strong>, with its satellite transmission hijacked to broadcast anti-military messages before being forcibly taken off-air [citation:2][citation:7]. The attack marks one of the most high-profile cyber incidents targeting Pakistani media in recent years.
          </p>

          {/* Incident Details Card */}
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-4 sm:p-6 shadow-sm">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center gap-2">
              <span className="w-1 h-6 sm:h-8 bg-red-600 rounded-full"></span>
              The Hijack: What Happened
            </h2>
            
            <div className="space-y-4">
              <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                <h3 className="font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                  <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  The Breach
                </h3>
                <p>
                  Unknown hackers successfully gained unauthorized access to Geo News' satellite frequency, temporarily hijacking the channel's broadcast [citation:3][citation:4]. The attackers replaced regular programming with <strong>anti-military messages</strong>, displaying an image featuring Urdu text declaring, <span className="bg-red-50 dark:bg-red-900/30 px-2 py-1 rounded text-red-700 dark:text-red-300 font-mono text-sm">"Your Army is Your Enemy"</span> against a backdrop of an explosion and the Pakistani flag [citation:1][citation:8].
                </p>
              </div>

              <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4">
                <h3 className="font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                  <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Service Disruption
                </h3>
                <p>
                  Following the brief broadcast of unauthorized content, Geo News' satellite feed was immediately taken off-air, displaying a <strong>"service unavailable"</strong> or "channel currently unavailable" message to viewers [citation:3][citation:5]. Notably, the channel's digital platforms—including its website and mobile applications—remained fully operational throughout the incident [citation:3][citation:4][citation:6].
                </p>
              </div>
            </div>
          </div>

          {/* Attack Timeline - Mobile Optimized */}
          <div className="bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-xl p-4 sm:p-6">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white mb-4">Attack Timeline</h2>
            <div className="space-y-3">
              {timelineEvents.map((event, index) => (
                <div key={index} className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 pb-3 border-b border-slate-200 dark:border-slate-700 last:border-0">
                  <span className="font-mono text-sm bg-slate-200 dark:bg-slate-700 px-2 py-1 rounded text-slate-700 dark:text-slate-300 whitespace-nowrap">
                    {event.time}
                  </span>
                  <div>
                    <h4 className="font-bold text-slate-900 dark:text-white">{event.event}</h4>
                    <p className="text-sm text-slate-600 dark:text-slate-400">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Official Response */}
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-4 sm:p-6">
            <h2 className="text-xl sm:text-2xl font-bold text-blue-900 dark:text-blue-100 mb-4 flex items-center gap-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
              Official Response: Geo News Statement
            </h2>
            
            <div className="space-y-4 text-blue-800 dark:text-blue-200">
              <div className="bg-white dark:bg-slate-800 rounded-lg p-4 border border-blue-100 dark:border-blue-800">
                <p className="italic">
                  "Geo News management confirmed the channel's screen was hacked and an inappropriate message was displayed. The network emphasized that the incident was entirely external and had no connection to the channel's content or staff" [citation:2][citation:7].
                </p>
              </div>
              
              <ul className="list-disc list-inside space-y-2 ml-2">
                <li>Attack was culmination of <strong>nearly 24 hours of repeated attempts</strong> to breach systems [citation:2][citation:7]</li>
                <li>Geo News formally urged Pakistani authorities and PEMRA to investigate [citation:2][citation:7]</li>
                <li>Demanded immediate action against those responsible [citation:7]</li>
              </ul>
            </div>
          </div>

          {/* Technical Analysis */}
          <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 sm:p-6">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white mb-4">Technical Analysis</h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white dark:bg-slate-700 p-4 rounded-lg">
                <h3 className="font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                  <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Attack Vector
                </h3>
                <p className="text-sm">Satellite frequency spoofing/hijacking via uplink interference or frequency override [citation:3][citation:4][citation:5]</p>
              </div>
              
              <div className="bg-white dark:bg-slate-700 p-4 rounded-lg">
                <h3 className="font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  Digital Security
                </h3>
                <p className="text-sm">Website and mobile apps remained secure - attack isolated to satellite transmission [citation:3][citation:4][citation:6]</p>
              </div>
            </div>
          </div>

          {/* Related Historical Incidents */}
          <div className="border-t border-slate-200 dark:border-slate-700 pt-6 mt-6">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white mb-4">Similar Media Cyber Attacks</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <Link to="/event/estonia-cyber-attacks" className="block p-3 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                <span className="font-semibold text-slate-900 dark:text-white">🇪🇪 Estonia 2007</span>
                <p className="text-sm text-slate-600 dark:text-slate-400">First state-backed cyber attacks targeting media</p>
              </Link>
              <Link to="/event/tv5monde-hack" className="block p-3 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
                <span className="font-semibold text-slate-900 dark:text-white">🇫🇷 TV5Monde 2015</span>
                <p className="text-sm text-slate-600 dark:text-slate-400">French network broadcast hijacked by hackers</p>
              </Link>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-600 p-4 sm:p-6 rounded-r-lg mt-6">
            <h3 className="font-bold text-lg text-red-800 dark:text-red-200 mb-2">
              Current Status - March 1, 2026
            </h3>
            <ul className="list-disc list-inside text-red-700 dark:text-red-300 space-y-2">
              <li>Investigation launched by Pakistani authorities and PEMRA</li>
              <li>Satellite feed remains disrupted pending security review [citation:3][citation:6]</li>
              <li>Digital platforms (website/app) operating normally [citation:1][citation:8]</li>
              <li>No group has officially claimed responsibility yet</li>
              <li>Geo News pursuing legal action against perpetrators [citation:2][citation:7]</li>
            </ul>
          </div>
        </div>

        {/* Footer Navigation - Mobile Optimized */}
        <footer className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-slate-200 dark:border-slate-700">
          <div className="flex flex-wrap gap-2 sm:gap-4">
            <Link
              to="/blog"
              className="inline-flex items-center px-3 py-2 text-sm bg-slate-100 dark:bg-slate-800 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors"
            >
              ← Blog Home
            </Link>
            <Link
              to="/blog/live-cyber-attacks"
              className="inline-flex items-center px-3 py-2 text-sm bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-200 rounded-lg hover:bg-red-200 dark:hover:bg-red-800 transition-colors"
            >
              Live Cyber Attacks →
            </Link>
          </div>
          
          <div className="mt-6">
            <h3 className="font-bold text-slate-900 dark:text-white mb-3 text-sm sm:text-base">Related Coverage:</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              <Link to="/decade/2020-2025" className={styles.link}>Recent Media Hacks</Link>
              <Link to="/event/satellite-hacks" className={styles.link}>Satellite Security</Link>
              <Link to="/blog/pakistan-cyber-news" className={styles.link}>Pakistan Cyber News</Link>
              <Link to="/toolkit/broadcast-security" className={styles.link}>Broadcast Security</Link>
              <Link to="/event/pemra-investigations" className={styles.link}>PEMRA Actions</Link>
              <Link to="/blog/media-hacking-trends" className={styles.link}>Media Hacking Trends</Link>
            </div>
          </div>
        </footer>
      </article>
    </div>
  );
};

export default GeoNewsHackIncident;
